/* eslint-disable eslint-comments/no-restricted-disable */

import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type OnboardingConfigProviderBacklogEntrypointComponent = EntryPointComponent<
	{},
	{},
	{},
	{} | null
>;

export const onboardingConfigProviderBacklogEntrypoint: EntryPoint<
	OnboardingConfigProviderBacklogEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<OnboardingConfigProviderBacklogEntrypointComponent>(
		/* webpackChunkName: "ai-rovo-jira-find-onboarding-backlog-config-provider" */ './OnboardingConfigProviderBacklogEntry.tsx',
	),
	getPreloadProps: () => ({}),
});
